import { render, staticRenderFns } from "./RecomTradeinAndSellArticle.vue?vue&type=template&id=763aa82f"
import script from "./RecomTradeinAndSellArticle.vue?vue&type=script&lang=js"
export * from "./RecomTradeinAndSellArticle.vue?vue&type=script&lang=js"
import style0 from "./RecomTradeinAndSellArticle.vue?vue&type=style&index=0&id=763aa82f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports